var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.producer)?_c('DashboardProducer'):_vm._e(),(_vm.distributor)?_c('DashboardDistributor'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }